import { useTranslation } from 'react-i18next';
import { taskAuditLines, type TaskAuditSource } from './taskAuditModel';

/**
 * "נוצר ע״י ‹שם› · ‹תאריך›" / "נערך לאחרונה ע״י ‹שם› · ‹תאריך›": small and
 * quiet (text-xs, text-3). Names and dates are isolated (`bdi`) so a Latin
 * name next to "·" keeps its order in RTL. Nothing renders without data.
 */
export default function TaskAuditLines({ task, className = '' }: { task: TaskAuditSource | null | undefined; className?: string }) {
  const { t } = useTranslation();
  const lines = taskAuditLines(task);
  if (!lines.length) return null;
  return (
    <div className={`space-y-0.5 text-xs text-text-3 ${className}`} data-task-audit="">
      {lines.map((l) => (
        <p key={l.kind}>
          {t(l.labelKey)}
          {l.name && <> <bdi className="text-text-2">{l.name}</bdi></>}
          {' · '}
          <bdi className="tabular-nums">{l.date}</bdi>
        </p>
      ))}
    </div>
  );
}
